import React, { useState, /**useEffect,*/ useRef } from 'react';
import { useToast } from 'react-native-toast-notifications';
import { useRoute } from '@react-navigation/native';
import { googleLogout } from '@react-oauth/google';
import { useAppDispatch } from '../../hooks';
import { Page, BLink, BText, showToast } from '../../components';
import { Input, Button, FormContainer, ButtonContainer, InputRefProps, TextContainer } from '../../components/Form';
import { UserModel, UserInputSchema /**MasterCityModel, MasterStateModel*/ } from '../../types';
import { yupErrorsMessage } from '../../utils/yup';
// import getService from '../../services/geoService';
import userService from '../../services/userService';
import { setLoading } from '../../store/portal/portalActions';

export const UserRegistration = ({ navigation }: any) => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const route = useRoute();

  const inputMobileNo = useRef<InputRefProps>(null);
  const inputPassword = useRef<InputRefProps>(null);
  const inputCfmPassword = useRef<InputRefProps>(null);
  const inputName = useRef<InputRefProps>(null);
  const inputEmail = useRef<InputRefProps>(null);

  const { name } = route.params as { name: string };
  const { email } = route.params as { email: string };
  const { otherLogin } = route.params as { otherLogin: boolean };

  // const inputDOB = useRef<InputRefProps>(null);
  // const inputState = useRef<InputRefProps>(null);
  // const inputCity = useRef<InputRefProps>(null);

  const [profile, setProfile] = useState<UserModel | undefined>();
  // const [states, setStates] = useState<MasterStateModel>();
  // const [cities, setCities] = useState<MasterCityModel>();

  // useEffect(() => {
  //   // load master data
  //   dispatch(setLoading(true));
  //   getService.getStates().then(res => {
  //     dispatch(setLoading(false));
  //     setStates(
  //       res.data
  //         .map((row: any) => {
  //           row.value = row.code;
  //           row.label = row.state;
  //           return row;
  //         })
  //         .sort((a: any, b: any) => a.label.localeCompare(b.label)),
  //     );
  //   });
  // }, []);

  // useEffect(() => {
  //   // when state updated, fetch city
  //   if (profile?.state) {
  //     dispatch(setLoading(true));
  //     getService.getCityByState(profile?.state).then(res => {
  //       dispatch(setLoading(false));
  //       setCities(
  //         res.data
  //           .map((label: string) => {
  //             let row = {
  //               value: label,
  //               label: label,
  //             };

  //             return row;
  //           })
  //           .sort((a: any, b: any) => a.label.localeCompare(b.label)),
  //       );
  //     });
  //   }
  // }, [profile?.state]);

  const doRegisterBtn = async () => {
    dispatch(setLoading(true));

    let user: UserModel = {
      mobileNo: inputMobileNo.current?.value || '',
      password: inputPassword.current?.value || '',
      confirmPassword: inputCfmPassword.current?.value || '',
      email: inputEmail.current?.value || '',
      name: inputName.current?.value || '',
      // dob: new Date(inputDOB.current?.value || '') || null,
      // state: inputState.current?.value || '',
      // city: inputCity.current?.value || '',
    };
    setProfile(user);
    UserInputSchema.validate(user, { abortEarly: false, context: { isNew: true } })
      .then(async (obj: any) => {
        let res = await userService.createUser(obj);
        if (res.data.resultCode === 0 || res.data.resultCode === 1) {
          googleLogout();
          dispatch(setLoading(false));
          let mobileNo = user.mobileNo;
          navigation.navigate('otpValidation', { mobileNo });
        } else {
          dispatch(setLoading(false));
          showToast(toast, { message: res.data.resultMessage, type: 'error' });
        }
      })
      .catch((err: any) => {
        console.log(yupErrorsMessage(err));
        showToast(toast, { message: yupErrorsMessage(err).join('\n'), type: 'error' });
        dispatch(setLoading(false));
      });
  };

  return (
    <Page title={'User Register'}>
      <FormContainer title="">
        <Input
          label={'Mobile Number'}
          id="mobileNumber"
          value={profile?.mobileNo}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          ref={inputMobileNo}
        />
        <Input
          label={'Password'}
          id="password"
          type="password"
          value={profile?.password}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          desc="Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
          ref={inputPassword}
        />

        <Input
          label={''}
          id="confirmPassword"
          type="password"
          value={profile?.confirmPassword}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          ref={inputCfmPassword}
        />

        <Input
          label={'Name'}
          id="name"
          // value={profile?.name}
          value={otherLogin ? name : profile?.name}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          ref={inputName}
          readOnly={otherLogin}
        />

        <Input
          label={'Email'}
          id="email"
          type="email"
          // value={profile?.email}
          value={otherLogin ? email : profile?.email}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          ref={inputEmail}
          readOnly={otherLogin}
        />

        {/* <Input
          label={'Birthdate'}
          id="dob"
          type="date"
          value={profile?.dob}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          ref={inputDOB}
        /> */}

        {/* <Input
          label={'State'}
          id="state"
          type="select"
          dataSource={states}
          value={profile?.state}
          onChange={(v: string) => setProfile({ ...profile, state: v })}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          ref={inputState}
        /> */}

        {/* <Input
          label={'City'}
          id="city"
          type="select"
          dataSource={cities}
          value={profile?.city}
          schemaObject={UserInputSchema}
          schemaContext={{ isNew: true }}
          ref={inputCity}
        /> */}

        <ButtonContainer>
          <Button onPress={() => doRegisterBtn()}>Register</Button>
        </ButtonContainer>

        <TextContainer align="center">
          <BLink to={{ screen: 'login' }}>Login</BLink>
          <BText> | </BText>
          <BLink to={{ screen: 'forgot-password' }}>Forget Password</BLink>
        </TextContainer>
      </FormContainer>
    </Page>
  );
};
